import React from "react";
import { Box, Typography, Avatar } from "@mui/material";

export default function CandidateProfileCard({ profile }) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" py={4}>
      <Avatar sx={{ width: 96, height: 96, mb: 2 }} />
      <Typography variant="h4" fontWeight={600} gutterBottom>
        {profile.first_name} {profile.last_name}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {profile.email} {profile.phone_number ? `| ${profile.phone_number}` : ""}
      </Typography>
    </Box>
  );
}
